<template>
<block-assets
   :mediaPickerOpen="mediaPickerOpen"
   :channelRecid="currActiveChannelRecid"
   :isLoadingSlots="isLoadingSlots"
   :isDragging="isDragging"
   :assetIsOver="assetIsOver"
   :mpAssetTypes="mpAssetTypes"
   :currSelectedAsset="currSelectedAsset"
   :isScoreboard="isGameInstance"
   :hideAddSlot="isScoreboardVert && isGameBlock && Object.values(slots).length == 0"
   :isEditingInstance="isEditingInstance"
   @addSlotClicked="handleAddSlotClicked"
   @dragOver="handleDragOver"
   @drop="handleDrop"
   @mouseLeave="handleMouseLeave"
>
   <div slot="slotlist">
      <program-block-slot-list
         v-if="Object.values(slots).length > 0"
         :slots="Object.values(slots)"
         :isTrigger="isTrigger"
      ></program-block-slot-list>

      <div v-else-if="isScoreboardVert && isGameBlock" class="empty-game-row" @click="handleGameSlotClicked">
         Choose your Game Instance
      </div>
   </div>
</block-assets>
</template>

<script>
import BlockAssets from '@/global/detail_display/BlockAssets';
import { mapActions, mapState } from 'vuex';

import ProgramBlockSlotList from './ProgramBlockSlotList';

export default {

   data() {
      return {
         assetIsOver: false
      }
   },

   props: {
      isTrigger: Boolean,
      isFeed: Boolean,
      channelRecid: Number | String,
      saved: Boolean,
      showMP: Boolean
   },

   computed: {
      ...mapState([
         'currActiveBlockRecid',
         'currActiveChannelRecid',
         'isGameBlock'
      ]),
      ...mapState('program_block', [
         'isLoadingSlots',
         'addSlotState',
         'slots',
         'mpAssetTypes',
         'currSelectedAsset',
         'isGameInstance',
         'currSelectedSlot',
         'isAddingGameSlot',
         'isEditingInstance'
      ]),
      ...mapState('global', [
         'mediaPickerOpen',
         'draggingAssetRecid',
         'draggingAssetType',
         'selectedAssets',
         'assignedAsset',
         'verticalId'
      ]),

      //if there is currently an asset being dragged, return true
      isDragging() {
         return this.draggingAssetRecid > 0;
      },

      isScoreboardVert() {
         return this.verticalId == 200;
      }
   },

   mounted() {
      this.getSlots();
   },

   methods: {
      ...mapActions('global', [
         'openMediaPicker',
         'resetMP',
      ]),
      ...mapActions('program_block', [
         'changeAddSlotState',
         'fetchSlots',
         'addSlots',
         'addSlot',
         'addGameSlot',
         'changeSlotAsset',
         'changeAddSlotStateForGameInstance',
         'handleMediaPickerClose'
      ]),

      getSlots() {
         this.fetchSlots({vm: this, blockRecid: this.currActiveBlockRecid});
      },

      handleAddSlotClicked() {
         if (!this.addSlotState) {
            this.changeAddSlotState({vm: this});
            this.openMediaPicker({});
         }
      },

      handleGameSlotClicked() {
         this.changeAddSlotStateForGameInstance();
         this.openMediaPicker({});
      },

      handleDragOver(e) {
         e.preventDefault();
         if (this.isDragging) {
            this.assetIsOver = true;
         }
      },
      
      handleDrop(e) {
         e.preventDefault();
         this.addSlots({assets: this.selectedAssets});

         this.resetMP({});
      },

      handleMouseLeave(e) {
         if (this.isDragging) {
            this.assetIsOver = false;
         }
         this.assetIsOver = true;
      },

      //we use two different components for normal slot rows vs.
      //slot rows with a feed asset assigned
      slotComponent(slot) {
         if (!this.isGameBlock) {
            if (slot.c_asset_type == 6) {
               return 'program-block-feed-slot-row';
            } else {
               return 'program-block-slot-row';
            }
         } else {
            if (slot.c_asset_type == 6) {
               return 'program-block-game-feed-slot-row';
            } else {
               return 'program-block-game-slot-row';
            }
         }
      },
   },

   watch: {
      assignedAsset() {
         if (this.assignedAsset) {
            if (this.isAddingGameSlot) {
               if (this.slots[this.currSelectedSlot] && this.slots[this.currSelectedSlot].assetRecid > 0 && this.currSelectedSlot != 0 && this.assignedAsset.recid > 0) {
                  //editing slot
                  this.changeSlotAsset({asset: this.assignedAsset});
               } else if (this.assignedAsset.recid > 0) {
                  //creating new slot
                  this.addGameSlot({asset: this.assignedAsset});
               }
            } else {
               let assetRecid = this.slots[this.currSelectedSlot].assetRecid;
               if (assetRecid > 0 && this.currSelectedSlot != 0 && this.assignedAsset.recid > 0) {
                  //editing slot
                  this.changeSlotAsset({asset: this.assignedAsset});
               } else if (this.assignedAsset.recid > 0) {
                  //creating new slot
                  this.addSlot({asset: this.assignedAsset});
               }
            }
         }
      },

      mediaPickerOpen() {
         if (!this.mediaPickerOpen) {
            this.handleMediaPickerClose();
         }
      }
   },

   components: {
      BlockAssets,
      ProgramBlockSlotList,
   }
}
</script>

<style lang="scss" scoped>
.empty-game-row {
   border-top: 1px solid #354658;
   border-bottom: 1px solid #354658;

   height: 95px;
   display: flex;
   align-items: center;
   justify-content: center;

   &:hover {
      cursor: pointer;
      color: $bard-gold;
   }
}
</style>

